// extracted by mini-css-extract-plugin
var _1 = "II-T9__userButton";
export { _1 as "userButton" }
